export default __webpack_public_path__ + "static/media/market-na.97a18ca5.webp";